import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import { keyByProperty } from '../../../helpers/core';
import Api from '../../../helpers/api';
import { t } from '../../../i18n';

const api = new Api('terms_and_privacy');

function* loadData() {
  try {
    const result = yield call(sendRequest, api.load, {}, notifications.REQUEST_ERROR);

    if (result && result.data && result.data.success && result.data.success.data) {
      yield put(actions.loadDataSuccess({ data: result.data.success.data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* updateTermsPrivacy({ payload }) {
  try {
    const { editForm } = payload;
    const propsArray = Object.values(editForm);
    const terms_and_privacy = keyByProperty(propsArray, 'name', prop => prop.value);
    const result = yield call(
      sendRequest,
      api.updateItem,
      { data: { terms_and_privacy } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(actions.saveSuccess({ data: terms_and_privacy }));
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.updated_successfully', {
            item: t('dash.admin.terms&privacy.terms_and_privacy'),
          }),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadData, updateTermsPrivacy };
export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.SAVE, updateTermsPrivacy)]);
}
